import {useEffect, useState} from 'react'
import {useSegments} from './useSegmentsByGroupId'

export const useAllSegments = () => {
  const [allSegments, setAllSegments] = useState([])
  const [page, setPage] = useState(0)

  const {data, isLoading, isFetching} = useSegments(page, 50)

  const isDone = data?.data?.length === 0

  useEffect(() => {
    if (!data || isFetching || isDone) return

    setAllSegments(prev => [...prev, ...data.data])
    setPage(prev => prev + 1)
  }, [data, isFetching, isDone])

  return {
    allSegments,
    isLoading: isLoading,
  }
}
